/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import _ from 'lodash'
import { Table, Button, Form, Popup, Icon, Input } from 'semantic-ui-react'
import TextareaAutoSize from 'react-textarea-autosize'

export default class EditGroupItemRow extends React.PureComponent {
  renderCustomable = (item, itemKey) => {
    const { saving, nameChange } = this.props

    if (item.customable) {
      return <Input name={itemKey} value={item.name} onChange={nameChange} type="text" disabled={saving} />
    }

    return item.name || item.data.name || '...'
  }

  renderUsersAbleToAdd = () => {
    const { usersNotOwnItem, addItemOwner } = this.props

    return (
      <Popup
        trigger={
          <div
            style={{
              textAlign: 'center',
              cursor: 'pointer',
              textDecorationLine: 'underline',
            }}
          >
            Add Owners?
          </div>
        }
        hideOnScroll
        flowing
        hoverable
        position="top center"
      >
        <div style={{ width: 300 }}>
          {_.map(usersNotOwnItem, user => {
            return (
              <div
                style={{
                  marginBottom: 3,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ display: 'flex', flex: 1 }}>- {user.name}</div>
                <div
                  style={{
                    textDecorationLine: 'underline',
                    cursor: 'pointer',
                    display: 'flex',
                  }}
                  onClick={() => addItemOwner(user)}
                >
                  Add ?
                </div>
              </div>
            )
          })}
        </div>
      </Popup>
    )
  }

  render() {
    const {
      item,
      itemKey,
      saving,
      usersNotOwnItem,
      removeItem,
      increaseQty,
      decreaseQty,
      specialNoteChange,
      priceChange,
    } = this.props

    return (
      <Table.Row>
        <Table.Cell collapsing>
          <Icon name="remove circle" color="red" onClick={removeItem} style={{ cursor: 'pointer' }} />
        </Table.Cell>
        <Table.Cell>{this.renderCustomable(item, itemKey)}</Table.Cell>
        <Table.Cell textAlign="right" collapsing>
          {_.map(item.belong_to, (user, userKey) => {
            return (
              <div style={{ margin: '4px 0px' }} key={userKey}>
                <span>{user.name}:</span>
                <Button.Group style={{ marginLeft: 16 }}>
                  <Button disabled={saving} color="black" onClick={() => decreaseQty(userKey)}>
                    -
                  </Button>
                  <Button>{user.quantity}</Button>
                  <Button disabled={saving} color="black" onClick={() => increaseQty(userKey)}>
                    +
                  </Button>
                </Button.Group>
              </div>
            )
          })}

          {usersNotOwnItem.length === 0 ? null : this.renderUsersAbleToAdd()}
        </Table.Cell>
        <Table.Cell textAlign="center" collapsing>
          <Input
            name="price"
            value={item.price_at_order}
            onChange={priceChange}
            type="number"
            step={0.01}
            disabled={saving}
          />
        </Table.Cell>
        <Table.Cell>
          {_.map(item.belong_to, (user, userKey) => {
            return (
              <div style={{ margin: '4px 0px' }} key={userKey}>
                <div style={{ marginBottom: 6 }}>{user.name}:</div>
                <Form>
                  <TextareaAutoSize
                    placeholder="Special note..."
                    rows={1}
                    minRows={1}
                    onChange={e => specialNoteChange(e.target.value, userKey)}
                    value={user.special_note || ''}
                    disabled={saving}
                  />
                </Form>
              </div>
            )
          })}
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/EditGroupItemRow.js